import { useState, useMemo } from 'react';
import { registerResponseHook } from '../flows/shared/services/decorated-service';
import config from '../config';

const IDLE_WARNING_TIME = 780000; // warn after 13 min
const IDLE_EXPIRE_TIME = 120000; // expire the session after 2 min after warning

export const createTimer = (expiry, timerUpCallback) => {
  let timer;

  const startTimer = () => {
    timer = setTimeout(timerUpCallback, expiry);
  };

  const stopTimer = () => {
    clearTimeout(timer);
  };
  const restartTimer = () => {
    stopTimer();
    startTimer();
  };

  return {
    timer,
    startTimer,
    stopTimer,
    restartTimer
  };
};

export default () => {
  const [warningTimeExpired, setWarningTimeExpired] = useState(false);
  const [userSessionExpired, setUserSessionExpired] = useState(false);

  const logout = () => {
    window.location.href = `${config(
      'clxUrl'
    )}/usis/login/logout?sdurl=${config(
      'clxUrl'
    )}/usis/my-accounts/post-logout`;
  };

  const restartMemoizedTimers = useMemo(() => {
    const expiryTimer = createTimer(IDLE_EXPIRE_TIME, () => {
      setUserSessionExpired(true);
    });

    const warningTimer = createTimer(IDLE_WARNING_TIME, () => {
      expiryTimer.startTimer();
      setWarningTimeExpired(true);
    });

    const restartTimers = () => {
      expiryTimer.stopTimer();
      warningTimer.restartTimer();
      setWarningTimeExpired(false);
    };

    registerResponseHook(restartTimers);

    warningTimer.startTimer();

    return restartTimers;
  }, []);

  return {
    warningTimeExpired,
    setWarningTimeExpired,
    userSessionExpired,
    restartMemoizedTimers,
    logout
  };
};
